module.exports = __webpack_public_path__ + "static/operations-excellence-fa0226c600b1c6b244282b2c03aa8622.svg";